import __var_0__ from './primitive.js';
import __var_1__ from './object.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isPrimitive = __var_0__;
var isObject = __var_1__;


// MAIN //

/**
* Tests if a value is a negative number.
*
* @param {*} value - value to test
* @returns {boolean} boolean indicating whether value is a negative number
*
* @example
* var bool = isNegativeNumber( -5.0 );
* // returns true
*
* @example
* var bool = isNegativeNumber( new Number( -5.0 ) );
* // returns true
*
* @example
* var bool = isNegativeNumber( -3.14 );
* // returns true
*
* @example
* var bool = isNegativeNumber( 5.0 );
* // returns false
*
* @example
* var bool = isNegativeNumber( null );
* // returns false
*/
function isNegativeNumber( value ) {
	return ( isPrimitive( value ) || isObject( value ) );
}


// EXPORTS //
export default isNegativeNumber;
